import React, { useMemo } from 'react';
import { CUSTOM_MESSAGES, LABEL } from '@veriables';
import Modal from '@components/common/Modal';
import { TouchableButton } from '@components/common/Touchable';
import cn from 'classnames';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  handleVoidItems,
  handleVoidCheck,
} from '../../CartButtons/CartActionHandler';
import { closeManagerCheck } from '@reducers/oauth';
import { setVoidCheckOpen } from '@reducers/orders';
import { bindActionCreators } from 'redux';
import { addInProcessItemsToCart } from '../../../MenuOrderHandler';
import store from '@store';

const VoidCheckModal = ({
  isVoidOpen,
  setIsVoidOpen,
  resetCheckBoxState,
  isTogo,
  isDriveThru,
  isCounter,
  isCallCenter,
  isSpeedOrderMode,
  ...props
}) => {
  const navigate = useNavigate();
  const {
    serverAppTheme,
    voidCheckOpen,
    closeManagerCheck,
    setVoidCheckOpen,
    seat,
  } = props; // Redux Imports
const { orders } = store.getState();
  const menuOrderStyles = useMemo(() => {
    const parentStyle = {
      backgroundColor: serverAppTheme?.background_color,
    };
    const tileBgMore = {
      background: serverAppTheme?.tile_bg_more,
    };
    const repostStyle = {
      backgroundColor: serverAppTheme?.background_color,
    };
    const voidStyle = {
      backgroundColor: serverAppTheme?.popUp_bg,
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
      borderRadius: '16px',
      width: '486px',
      margin: 'auto',
      minHeight: '216px',
    };
    const voidText = {
      color: serverAppTheme?.primary_text,
    };
    const noButton = {
      background: serverAppTheme?.OFF_Premise_Btn,
      border: serverAppTheme?.cancleBtn_Border,
      color: serverAppTheme?.cancleBtn_font,
    };
    const yesButton = {
      background: serverAppTheme?.secondaryBtn,
      color: serverAppTheme?.btn_font_color,
    };

    return {
      parentStyle,
      tileBgMore,
      repostStyle,
      voidStyle,
      voidText,
      noButton,
      yesButton,
    };
  }, [serverAppTheme]);

  const handleCloseVoidCheck = () => {
    setIsVoidOpen(false);
    setVoidCheckOpen(false);
    closeManagerCheck();
    resetCheckBoxState(false);
  };

  const handleYesClick = () => {
    if (voidCheckOpen) {
      handleVoidCheck({
        closeVoidCheck: () => handleCloseVoidCheck(),
        navigate: navigate,
      });
    } else {
      handleVoidItems({
        closeVoidCheck: () => handleCloseVoidCheck(),
        navigate: navigate,
        isSingleItemClick: true,
      });
    }
  };
  const callCenterClose = () => {
    const cb = () => handleYesClick();
      addInProcessItemsToCart(cb, orders?.cart);
  };
  return (
    <Modal
      isOpen={isVoidOpen}
      loading={props.loading}
      isModalCenter
      noBackground
      style={menuOrderStyles.voidStyle}
      customClass="h-100 w-100"
      customClass2="h-100 w-100"
    >
      <div
        className="m-2 justify-content-center align-items-center text-center  h-100 "
        style={menuOrderStyles.voidText}
      >
        <div className="col-12 py-2 fs_18 fw-700 text-center h-25">
          Are You Sure?
        </div>
        <div className="col-12 d-flex p-0 py-1 h-auto justify-content-center">
          <div className="col-9 px-3 fs_15 fw-normal text-center">
            {(isTogo || isCallCenter || isSpeedOrderMode || isDriveThru || isCounter) ? (
              CUSTOM_MESSAGES().CANCEL_ORDER
            ) : voidCheckOpen ? (
              seat.paidAmount > 0 ? (
                <>
                  <text className="fs_15">
                    {' '}
                    {CUSTOM_MESSAGES().CHECK_VOID_ERRER}
                  </text>
                  <text> {CUSTOM_MESSAGES().CHECK_VOID} </text>
                </>
              ) : (
                CUSTOM_MESSAGES().CHECK_VOID
              )
            ) : (
              CUSTOM_MESSAGES().SENT_VOID
            )}
          </div>
        </div>
        <div
          className="col-11 d-flex mt-2 justify-content-center align-items-center align-items-end text-center h-20 position-absolute"
          style={{ bottom: '26px', left: '20px' }}
        >
          <TouchableButton
            className={cn('col-6 h-100 mr-1 btn90 fs_24')}
            style={menuOrderStyles.noButton}
            type="button"
            onClick={e => {
              setIsVoidOpen(false);
              e.preventDefault();
            }}
            rippleEffect={true}
          >
            {LABEL().NO}
          </TouchableButton>
          <TouchableButton
            className={cn('col-6 h-100 ml-1 btn90 btn-ripple fs_24')}
            style={menuOrderStyles.yesButton}
            type="button"
            onClick={e => {
              e.preventDefault();
              isCallCenter ? callCenterClose() : handleYesClick()
            }}
            rippleEffect={true}
          >
            {LABEL().YES}
          </TouchableButton>
        </div>
      </div>
    </Modal>
  );
};

const MemoizedVoidCheckModal = React.memo(VoidCheckModal);

const mapStateToProps = ({ theme, orders }) => ({
  serverAppTheme: theme.serverAppTheme,
  voidCheckOpen: orders.voidCheckOpen,
  seat: orders.seats,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ closeManagerCheck, setVoidCheckOpen }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemoizedVoidCheckModal);
